<template>
  <div>
    <h1>{{ $t("global.logging-out") }}</h1>
  </div>
</template>

<script>
import { onMounted } from "@vue/composition-api";
import store from "@/store";

export default {
  name: "Logout",
  props: {
    redirect: String,
    reason: String,
  },
  setup(props, context) {
    onMounted(() => {
      store.dispatch("auth/logout").then(() => {
        context.root.$router.push({
          name: "login",
          query: { redirect: props.redirect, reason: props.reason },
        });
      });
    });
  },
};
</script>
